import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-06 10:05:53
 * @LastEditTime: 2022-01-12 16:51:21
 * @LastEditors: wangshengqiang
 * @Description: 单选
 */
import React from 'react';
import { Radio } from 'zarm';
import cn from 'classnames';
import FormItem from '@/baseComponents/FormItem';
import './index.less';

function RadioList(data) {
  return data.filter(item => item.isDefault !== false).map(item => {
    return /*#__PURE__*/React.createElement(Radio, {
      key: item.value,
      value: item.value
    }, item.label);
  });
}

export default function RowRadioList(props) {
  const {
    attrs,
    isPremiumFactor,
    label,
    formKey,
    isBenefitFactor,
    renderList,
    isRequired,
    disabled,
    onChange,
    initialValue,
    remark = {}
  } = props;
  const {
    dataSource,
    display = {}
  } = attrs;

  let _initialValue = display.hasDefaultValue && display.defaultValue ? JSON.parse(display.defaultValue) : undefined;

  if (initialValue) {
    _initialValue = initialValue;
  }

  const formItemProps = {
    name: formKey,
    label,
    remark,
    fieldOption: {
      rules: [{
        required: isRequired,
        message: '请选择'
      }],
      isPremiumFactor,
      isBenefitFactor,
      initialValue: _initialValue
    }
  };
  const childrenList = renderList ? renderList() : RadioList(dataSource);
  const childrenLength = React.Children.count(childrenList);
  const cls = cn({
    'radio-group-more': childrenLength > 3
  });
  return /*#__PURE__*/React.createElement(FormItem, _extends({}, props, formItemProps), /*#__PURE__*/React.createElement(Radio.Group, {
    onChange: onChange,
    type: "button",
    disabled: disabled,
    className: cls
  }, childrenList));
}